import {
  SanityContentCarouselItem,
  SanityContentCarouselItemType,
} from '@data/sanity/queries/types/blocks'
import { SanityVideoType } from '@data/sanity/queries/types/video'

import BlogPostCard from '@blocks/blog/blog-post-card'
import Freeform from '@blocks/freeform'
import LinkItem from '@components/link-item'
import Photo from '@components/photo'
import MuxVideo from '@components/video/mux-video'

interface ContentCarouselItemProps {
  item: SanityContentCarouselItem
}

const ContentCarouselItem = ({ item }: ContentCarouselItemProps) => {
  switch (item._type) {
    case SanityContentCarouselItemType.FREEFORM: {
      return (
        <Freeform
          content={item.freeform.content}
          textAlign={item.freeform.textAlign}
          maxWidth={item.freeform.maxWidth}
        />
      )
    }

    case SanityContentCarouselItemType.PHOTO: {
      return <Photo image={item.photo} />
    }

    case SanityContentCarouselItemType.BLOG_POST: {
      return (
        <BlogPostCard
          post={item.blogPost}
          options={{
            showDate: true,
          }}
        />
      )
    }

    case SanityContentCarouselItemType.VIDEO: {
      if (!item.video.muxVideo || item.video.type !== SanityVideoType.MUX) {
        return null
      }

      return (
        <MuxVideo
          video={item.video.muxVideo}
          thumbnailImage={item.video.thumbnailImage}
          showControls={item.video.settings?.controls}
          autoplay={item.video.settings?.autoplay}
          autoplayOnHover={item.video.settings?.autoplayOnHover}
          openModalOnClick={item.video.settings?.openModalOnClick}
          loop={item.video.settings?.loop}
          muted={item.video.settings?.muted}
          borderRadius={item.video.borderRadius}
          aspectRatio={item.video.aspectRatio}
        />
      )
    }

    case SanityContentCarouselItemType.LINK_ITEM: {
      return (
        <LinkItem
          title={item.linkItem.title}
          page={item.linkItem.page}
          image={item.linkItem.image}
        />
      )
    }
  }
}

export default ContentCarouselItem
